<template>
  <Layout>
    <div class="container">
      <div :style="{ backgroundImage: `url(${bannerUrl})` }" class="banner">
        <div class="banner-title">
          <div class="title">{{ bannerTitle }} <em>{{bannerTitleEn}}</em></div>
        </div>
      </div>
      <div class="main">
        <div class="content">
          <ul class="list">
            <router-link
              tag="li"
              :to="{ path: '/newDetails', query: { id: item.id } }"
              v-for="(item, i) in newsList"
              :key="item.id"
            >
              <div class="time">
                {{ $moment(item.createTime).format("yyyy/MM/DD") }}
              </div>
              <div class="text-title">
                {{ item.newsTitle }}
              </div>
            </router-link>
          </ul>
          <div style="text-align: center; padding-bottom: 30px">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              :total="total"
              prev-text="上一页"
              next-text="下一页"
            >
            </el-pagination>
          </div>
        </div>
        <div class="navs">
          <div
            v-for="item in newsTypeList"
            :key="item.id"
            class="nav-item"
            :class="searchParams.twoTypeId === item.id ? 'active' : ''"
            @click="searchParams = { ...searchParams, twoTypeId: item.id }"
          >
            <i class="icon el-icon-arrow-right"></i>
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "./../../components/Layout";
import Footer from "./../../components/Footer";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      banner1url: require("assets/images/news/banner1.png"),
      activeIndx: 0,
      newsList: [],
      total: 0,
      pageNo:1,
      pageSize: 10,
      onOff: true,
      activeTab: undefined,
      typeList: [],
      newsTypeList: [],
      searchParams: {
        oneTypeId: this.$route.query.id,
        twoTypeId: undefined,
        pageNum:this.pageNo,
        pageSize:10,
      },
    };
  },
  methods: {
    changeIndex(index) {
      this.activeIndx = index;
      this.onOff = !this.onOff;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getNewsList();
    },
    // 联盟大事记
    async getNewsList() {
      this.searchParams.pageNum = this.pageNo;
      const newsList = await this.$get("/fore/newsType/findNewsList",
        this.searchParams
      );
      this.newsList = (newsList.pageBean || {}).list;
      this.total = (newsList.pageBean || {}).total;
      if (this.newsTypeList && this.newsTypeList.length) return;
      this.newsTypeList = newsList.newsTypeVoList;
      if (this.newsTypeList) {
        this.searchParams.twoTypeId = this.newsTypeList[0].id;
        
      }
    },
    async getTypeList() {
      const typeList = await this.$get("/fore/newsType/findNewsTypeList", {
        id: this.$route.query.id,
      });
      this.typeList = typeList;
    },
    

  },
  created() {
    this.getNewsList();
    this.getTypeList();
  },
  computed: {
    bannerUrl() {
      const typeBanner = (this.typeList || []).find(
        (item) => item.id == this.$route.query.id
      );
      return (typeBanner || {}).bannerUrl;
    },
    bannerTitle() {
      const typeName = (this.typeList || []).find(
        (item) => item.id == this.$route.query.id
      );
      return (typeName || {}).name;
    },
    bannerTitleEn() {
      const typeName = (this.typeList || []).find(
        (item) => item.id == this.$route.query.id
      );
      return (typeName || {}).translationName;
    },
    key(){
        return this.$route.query.id !== undefined ? this.$route.query.id + new Date() : this.$route.query.id + new Date();
    }
  },
  watch: {
    "$route.query.id"(){
      this.newsList = [];
      this.newsTypeList =[];
      this.getNewsList();
    },
    searchParams(n) {
      this.getNewsList();
    },
  },
};
</script>  
<style lang="scss" scoped>
body,
ul,
h2 {
  /*组合选择器*/
  list-style: none; /*清除列表默认样式*/
  padding: 0; /*清除padding*/
  margin: 0;
}
.banner {
  height: 358px;
  position: relative;
  background-size:100%;
  background-repeat: no-repeat;
  .banner-title {
    height: 80px;
    background:url(~../../assets/images/titbg.png) left top no-repeat;
    background-size: 715px 80px;
    background-repeat: no-repeat;
    position: absolute;
    z-index: 3;
    bottom: 0;
    width: 100%;
    .title {
      width: 1400px;
      margin: 0 auto;
      font-size: 28px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
      em{
        font-size: 28px;
        font-family: TimesNewRomanPSMT;
        color: #FFFFFF;
        line-height: 32px;
        padding-left:20px;
        font-style:normal;
      }
    }
  }
}

.main {
  width: 1400px;
  margin: -40px auto 30px;
  background: #fff;
  padding: 70px 40px 30px 55px;
  display: flex;
  position: relative;
  z-index: 2;
  .content {
    width: 1000px;
    .list {
      li {
        margin-bottom: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        &:hover {
          .text-title {
            color: #1064d0;
          }
        }
        .time {
          font-size: 16px;
          color: #18169b;
          line-height: 18px;
          font-family: TimesNewRomanPSMT;
          &::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 3px;
            background: #b2b1e0;
            vertical-align: middle;
            margin: 0 16px 0 10px;
          }
        }
        .text-title {
          font-size: 18px;
          font-weight: 500;
          color: #2a2a2a;
          line-height: 25px;
          margin: 7px 0 10px 30px;
        }
        .iconfont {
          color: #b2b6bc;
          font-size: 20px;
          &:hover {
            color: #1064d0;
          }
        }
      }
    }
  }
  .navs {
    flex: 0 0 306px;
    margin-left: 60px;
    .nav-item {
      font-size: 20px;
      font-weight: 500;
      line-height: 68px;
      color: #2a2a2a;
      padding-left: 26px;
      background: #F8FBFF;
      box-shadow: 0px -1px 0px 0px #DDDDDD;
      cursor: pointer;
      .icon {
        color: transparent;
      }
      &.active {
        cursor: default;
        color: #fff;
        background: #1064d0;
        box-shadow: 0px -1px 0px 0px #dddddd;
        .icon {
          color: #fff;
        }
        &:hover{color:#fff;}
      }
      &:hover{color:#1064d0;}
    }
  }
  .international {
    display: flex;
    justify-content: center;
    padding: 30px 0;
    .pic {
      width: 400px;
      img {
        width: 100%;
        height: auto;
      }
    }
    h2 {
      font-size: 56px;
      margin: 25px 0;
    }
    .wait {
      text-align: center;
      font-size: 30px;
      color: #1064d0;
      padding-bottom: 20px;
    }
  }
}
</style>